import { render, staticRenderFns } from "./InspectOtherAnswer.vue?vue&type=template&id=e501aba4&scoped=true"
import script from "./InspectOtherAnswer.vue?vue&type=script&lang=ts"
export * from "./InspectOtherAnswer.vue?vue&type=script&lang=ts"
import style0 from "./InspectOtherAnswer.vue?vue&type=style&index=0&id=e501aba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e501aba4",
  null
  
)

export default component.exports